jQuery(document).ready(function ($) {
    $('.readmore-btn').on('click', function () {
        const $this = $(this);
        const cardDescription = $this.closest('.readmore-wrap').find('.readmore');
        cardDescription.toggleClass('expanded');
        $this.text(cardDescription.hasClass('expanded') ? 'Réduire' : 'Voir plus');

        if (cardDescription.hasClass('expanded')) {
            $this.text('Réduire');
        } else {
            $this.text('Voir plus');
            $('html, body').animate({
                scrollTop: $this.closest('.readmore-wrap').offset().top - 50
            });
        }
    });

});
